import { EnvironmentCheckPercentiles } from "../../lib/Api/CustomerSupport";

export enum EnvironmentCheckPercentileType {
    Top50Percentile,
    Top75Percentile,
    Top90Percentile,
    Top95Percentile
}

export function getValuePercentile(value?: number, percentiles?: EnvironmentCheckPercentiles): EnvironmentCheckPercentileType|undefined
{
    if (undefined === value)
        return undefined;

    if (percentiles?.top95Percent && value > percentiles.top95Percent)
        return EnvironmentCheckPercentileType.Top95Percentile;

    if (percentiles?.top90Percent && value > percentiles.top90Percent)
        return EnvironmentCheckPercentileType.Top90Percentile;

    if (percentiles?.top75Percent && value > percentiles.top75Percent)
        return EnvironmentCheckPercentileType.Top75Percentile;
    
    if (percentiles?.median && value > percentiles.median)
        return EnvironmentCheckPercentileType.Top50Percentile;

}
